import React from "react";
import { Helmet } from 'react-helmet-async';

const TermsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>利用規約 | オリパサイト作成サービス JOYBASE</title>
        <meta name="description" content="JOYBASEの利用規約です。オリパサイト作成SaaSサービスJOYBASEをご利用いただく店舗オーナー向けの利用条件を定めています。" />
        <meta property="og:title" content="利用規約 | オリパサイト作成サービス JOYBASE" />
        <meta property="og:description" content="JOYBASEの利用規約です。オリパサイト作成SaaSサービスJOYBASEをご利用いただく店舗オーナー向けの利用条件を定めています。" />
        <link rel="canonical" href="https://www.joybase.jp/terms" />
        <meta property="og:url" content="https://www.joybase.jp/terms" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <html lang="ja" />
      </Helmet>
      <section className="bg-white">
        <div className="mx-auto max-w-screen-xl px-4 pt-24 pb-8 sm:px-6 sm:pt-28 sm:pb-12 lg:px-8 lg:pt-32 lg:pb-16 flex items-center justify-center">
          <div className="max-w-xl lg:max-w-3xl">
            <h1 className="mt-6 text-2xl font-bold text-gray-900 sm:text-2xl text-center">JOYBASE利用規約</h1>

            <p className="mt-4 text-sm text-gray-700">
              本規約は、合同会社Codingholic（以下「当社」）が提供する「JOYBASE」（以下「本サービス」という）を利用してトレーディングカードのオリジナルパックの販売を行う、オリパサイトを運営する事業者に適用される利用条件を定めるものです。本規約は、当社と店舗オーナーとの間で締結される、本サービスの利用に関する契約（以下「本契約」）の一部を構成するものとします。
            </p>

            {/* 第１章　本規約について */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第１章　本規約について</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第1条（総則）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、本規約に同意の上、本サービスを利用するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーが、本サービスを利用する場合、本規約に同意したものとみなします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第2条（定義）</h3>
            <p className="mt-2 text-sm text-gray-700">本規約において、次に掲げる用語の定義は以下のとおりとします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li><strong>(1) 店舗オーナー：</strong>本サービスを利用してオリパサイトを運営する事業者</li>
              <li><strong>(2) 店舗ページ：</strong>店舗オーナーが本サービス上で運営するオリパサイト</li>
              <li><strong>(3) サーバ：</strong>当社が本サービスを運営するために管理するサーバ</li>
              <li><strong>(4) 顧客：</strong>店舗ページにおいてポイントおよび商品の購入を行うユーザー</li>
              <li><strong>(5) ポイント：</strong>各店舗オーナーがその店舗ごとに発行し、顧客がその店舗ページで使用することのできる有償又は無償のポイント</li>
              <li><strong>(6) 商品：</strong>店舗オーナーが店舗ページで販売する、トレーディングカードのオリジナルパックその他の商品</li>
              <li><strong>(7) 商品情報等：</strong>各店舗ページにおいて、店舗オーナーが顧客に対して表示する、掲載中の商品の概要・金額、注意事項、広告（掲載するイメージ画像等の一切を含む）その他一切の情報</li>
              <li><strong>(8) 管理責任者：</strong>本サービス上で運営される店舗ページに関して、店舗オーナーが定める責任者</li>
              <li><strong>(9) 売上：</strong>ポイントの購入をした決済金額から本サービス利用にかかる手数料等を控除した金額</li>
            </ul>

            {/* 第２章　アカウント登録と店舗開設 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第２章　アカウント登録と店舗開設</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第3条（アカウント登録）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 本サービスの利用には、会員登録が必要となります。本サービスを利用して店舗ページを運営することを希望する場合、当社所定の方法により申込をするものとします。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーとなることを希望する方は前項の申込みにあたり、本規約および当社が定めるプライバシーポリシーに同意する必要があります。これらに同意しない場合、本サービスを利用することはできません。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社が第1項の登録を承認した時点で、本サービスの利用登録が完了し、本契約が成立するものとし、店舗オーナーは本規約に従って本サービスを利用することができるようになります。</p>
            <p className="mt-2 text-sm text-gray-700">4. 当社は、店舗オーナーの利用登録が完了した場合、店舗オーナー専用のIDおよびパスワード等のアカウント情報を発行します。</p>
            <p className="mt-2 text-sm text-gray-700">5. 店舗オーナーは、本サービスのアカウントを自ら利用しなければならず、第三者に対して、貸与、譲渡、使用許諾、共有、名義貸し等をすることはできません。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第4条（アカウント登録の条件）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーとして登録するには、以下の条件を満たす必要があります。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 18歳以上であること</li>
              <li>(2) 日本国内に住所を有すること</li>
              <li>(3) 古物商許可証を取得していること（中古品を取り扱う場合）</li>
              <li>(4) 特定商取引法に基づく表記が可能であること</li>
              <li>(5) 当社の定める決済代行サービスの審査に通過すること</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、当社が必要だと判断した場合は、本サービスの利用を当社が定める本人確認などの手続を経て一定の要件を満たした場合のみに限定する等、利用に際して条件を付すことができるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社は、以下の場合に店舗登録を拒否または取り消すことができます。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 登録情報に虚偽がある場合</li>
              <li>(2) 過去に本規約違反により登録を取り消されたことがある場合</li>
              <li>(3) 反社会的勢力に該当する場合</li>
              <li>(4) その他、当社が不適切と判断した場合</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">4. 店舗オーナーは、登録情報に変更があった場合、速やかに変更手続きを行うものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第5条（登録事項）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、前条の申込みに際し、以下の事項をあらかじめ当社に登録するものとします。登録がなかったこと、および記載情報に誤りがあること（最新の情報に更新されなかったことを含みます）による損害は、店舗オーナーの負担とします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 店舗オーナーが法人の場合：商号（屋号）、代表者名<br />店舗オーナーが個人の場合：氏名</li>
              <li>(2) 住所</li>
              <li>(3) 取扱商品</li>
              <li>(4) 管理責任者の氏名、電子メールアドレス、電話番号</li>
              <li>(5) 売上の振込先口座</li>
              <li>(6) その他当社が指定する店舗オーナーに関する情報</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、前項の申込時に当社に登録する情報が、正確かつ最新の内容であることを保証するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 店舗オーナーは、申込時の情報に変更が生じた場合、速やかに当社に対し、当社の定める方法で変更後の情報を通知するものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第6条（当社からの連絡）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 本サービスに関する当社から店舗オーナーに対する連絡は、前条１項により届出のあった店舗オーナーの住所に書面を郵送する方法、管理責任者の電子メールにメールを送付する方法、当社所定のページに連絡事項を掲載・通知する方法またはその他当社が適当と判断する方法によって行います。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、当社から連絡があった場合は、速やかにこれを確認し、対応するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社が第１項による通知を行った場合、店舗オーナーの住所・メールアドレスの誤入力、これらの情報の変更届出の懈怠、郵送事故等によって、店舗オーナーへの連絡が不達となった場合であっても、以下の時点で、店舗オーナーに対する連絡が到達したものとみなします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 郵送の場合：発送日の翌日から起算して2営業日経過時点</li>
              <li>(2) メールの場合：メール送信日時</li>
              <li>(3) ウェブサイト上での掲載・通知：当該通知の時点</li>
              <li>(4) その他の場合：通知が到達するのに必要な相当な期間の経過時点</li>
            </ul>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第7条（店舗ページの開設）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、第３条の登録を完了した後、店舗ページ開設に向けて、以下の情報を設定します。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 店舗ページ名</li>
              <li>(2) 店舗ページのサブドメイン（○○○.joybase.jpの「○○○」部分）</li>
              <li>(3) 店舗ページの概要や特徴を記載した説明</li>
              <li>(4) その他当社の指定する情報</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 前項の情報の設定を完了した場合、店舗オーナーは、サーバ内の前項2号に指定されたURLに店舗ページを開設することができます。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第8条（アカウント情報の管理）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、第３条の登録等に基づき、設定されたパスワードについて、第三者に知られないよう管理し、定期的にパスワードの変更登録を行うなど、パスワードの盗用を防止する措置を自らの責任において行うものとします。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、商品情報等の送信その他本サービスへのアクセスに際しては、当社所定の方法により、設定されたIDおよびパスワードを入力しなければなりません。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社は、店舗オーナーのIDおよびパスワードを利用した、本サービスへのアクセスおよび一切の挙動について、店舗オーナーによるものとみなします。</p>
            <p className="mt-2 text-sm text-gray-700">4. 店舗オーナーが、設定されたIDおよびパスワードの不正使用その他の事故等により生じた損害について、当社は一切責任を負いません。</p>
            <p className="mt-2 text-sm text-gray-700">5. アカウントの不正使用を発見した場合は、直ちに当社まで通知してください。</p>

            {/* 第３章　商品の販売 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第３章　商品の販売</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第9条（ポイントについて）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、顧客に対し、商品を購入するためのポイントを発行することができます。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーが発行するポイントは、店舗ページ上での購入、その他店舗オーナーが別途指定する方法により、顧客に付与されるものです。ポイントの購入単位等の事項は、店舗オーナーが定めるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. ポイントを付与された顧客は、店舗ページにおいて商品の購入をすることができます。但しポイントは、その付与を行った当該店舗ページでのみ利用が可能であり、他のオーナーが管理する店舗ページで利用することはできません。</p>
            <p className="mt-2 text-sm text-gray-700">4. ポイントの有効期限は、ポイントごとに、その発行日から６ヶ月間とします。</p>
            <p className="mt-2 text-sm text-gray-700">5. 顧客は、ポイントを購入する際の代金の決済に関して、当社の指定する決済代行業者の提供するサービスを利用するものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第10条（販売に関する注意）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、顧客との間で、商品等の送付、代金の決済その他販売に必要な手続きを自らの責任で直接行うものとします。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーが本サービスを利用し、顧客と行う一切の取引の当事者は、店舗オーナーと顧客であり、当社は取引の当事者となりません。店舗オーナーは、顧客に対し、取引の当事者は店舗オーナーと顧客であり、販売等に伴う権利・義務は店舗オーナーと当該顧客との間で発生することを明確に表示するものとします。また、店舗オーナーは、顧客に対し、本規約に則った適切な顧客向けの規約を提示した上で、顧客との間で売買契約その他必要な契約を締結する必要があります。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社は、店舗オーナーに対して、前項の顧客向け規約等の文案を提示する場合があります。当社は当該文案について、その正確性、有用性、目的適合性、法令適合性等を一切保証せず、これによって、店舗オーナーに損害が生じた場合であっても当該損害の一切を賠償する責任を負いません。店舗オーナーは、規約等の文案を自らの責任で確認し、これを利用するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">4. 店舗オーナーは、商品の販売条件として、顧客が一方的に不利になるような条件を付してはなりません。また、店舗オーナーは、商品の販売条件に関する適切な説明を、店舗ページにおいて明示するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">5. 店舗オーナーは、販売を行うにあたり、特定商取引に関する法律、不当景品および不当表示防止法、古物営業法、個人情報保護法、刑法、およびこれに関連する規則やガイドライン、並びに、その他顧客とのやり取りをする上で関連する一切の法令等を遵守するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">6. 店舗オーナーは、次の各号のいずれかに該当する商品を販売してはなりません。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 本条第４項に違反する商品</li>
              <li>(2) 本規約等に違反する商品</li>
              <li>(3) 偽造品、盗品その他違法な商品</li>
              <li>(4) その販売が当社または第三者の権利を侵害する商品</li>
              <li>(5) 本サービスにふさわしくないと当社が判断した商品</li>
              <li>(6) その他前各号に準ずる商品</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">7. 店舗オーナーは顧客に対し、商品の品質、およびこれを適切に配送することを保証するものとします。また、顧客から商品や配送に関する問い合わせがあった場合には、誠実に対応するものとします。</p>
            <p className="mt-2 text-sm text-gray-700">8. 店舗オーナーは、顧客との間で、商品の不着、到着遅延、瑕疵その他の紛争が生じた場合、または商品情報等に関し第三者との間で著作権、商標権等の知的財産権もしくは人格権等に関する紛争が生じた場合には、すべて店舗オーナーの責任と負担において誠実に解決するものとし、当社に一切の迷惑をかけないものとします。</p>
            <p className="mt-2 text-sm text-gray-700">9. 前項にもかかわらず、当社が顧客その他の第三者に対し、損害賠償等の支払を余儀なくされた場合には、店舗オーナーはその全額を当社に支払うとともに、その解決のために要した弁護士費用その他一切の諸経費を当社に支払うものとします。</p>
            <p className="mt-2 text-sm text-gray-700">10. 当社は、店舗オーナーと顧客その他の第三者との間の紛争について、店舗オーナーの同意を得ることなく、当該顧客または第三者に対し当該紛争に関する情報提供その他の援助を行うことができるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">11. 店舗オーナーは、前項の紛争に関連して、当社が協力を求めた際は、これに協力するものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第11条（商品の確保等）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、商品の在庫が確保できていない場合、商品を出品することはできません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、前項の場合、商品情報等を削除するなど、適切な対応をとるものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第12条（商品情報の表示）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、店舗ページにおいて表示する商品情報等の制作にあたり、次の事項を遵守するものとします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 本規約に反する表示をしないこと</li>
              <li>(2) 虚偽または誤解を招く商品情報等の掲載をしないこと</li>
              <li>(3) わいせつ、グロテスクその他一般人が不快感を覚える表示をしないこと</li>
              <li>(4) 特定商取引に関する法律11条および同法施行規則23条により表示を義務づけられた事項について表示すること</li>
              <li>(5) その他、店舗オーナーの本サービスの利用に関連し、消費者保護法その他一切の法令に基づき、何らかの表示が求められる場合、当該表示を行うこと</li>
              <li>(6) 当社または第三者の、著作権、商標権、プライバシー権、肖像権その他一切の権利を侵害しないこと</li>
              <li>(7) 前号のほか、以下の事項について表示すること
                <ul className="mt-1 ml-4 list-none space-y-1">
                  <li>ア. 店舗の管理責任者の氏名、問い合わせ先</li>
                  <li>イ. 営業時間、定休日等</li>
                  <li>ウ. 商品についての問合わせおよび苦情は店舗オーナー宛に行うべきこと</li>
                  <li>エ. その他当社所定の事項</li>
                </ul>
              </li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、出店後、第１項その他本規約等により認められる範囲内で、店舗ページ上の商品情報等を改訂し、表示することができます。店舗オーナーは、商品情報等については、常に最新の情報をユーザーに提供するよう、定期的に更新を行うものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第13条（商品情報等の変更削除義務）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、次の各号の一に該当する場合、直ちに商品情報等を変更または削除しなければなりません。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 商品情報等に誤りまたは変更すべき内容がある場合</li>
              <li>(2) 商品または商品情報等が本規約等または法令等に違反する場合</li>
              <li>(3) 店舗オーナーが商品または商品情報等について行政指導または行政処分を受けた場合</li>
              <li>(4) 第三者が店舗オーナーの商品と同一の商品または商品情報等について行政指導または行政処分を受けた場合</li>
              <li>(5) 前四号に定める場合の他、商品または商品情報等が不適切であると当社が判断した場合</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、前各号に該当する商品情報等について、自らの判断で削除、訂正を行うことができます。</p>
            <p className="mt-2 text-sm text-gray-700">3. 前二号の定めに基づく商品情報等の削除、訂正によって店舗オーナーに損害が生じた場合であっても、当社は一切の損害を賠償する責任を負いません。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第14条（クレーム対応等）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、店舗オーナーまたは商品に関連して、顧客または第三者からクレームを受けた場合、自らの責任と費用において対応し解決を図るものとし、クレームの再発防止のために必要な措置を講じなければなりません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、店舗オーナーまたは商品に関連して、当社が顧客または第三者からクレームを受けた場合、本契約期間中はもとより本契約終了後においても、自己の責任と費用でこれを解決するものとし、当社にいかなる迷惑もかけないものとします。当社が損害を被った場合、店舗オーナーは損害の一切（弁護士費用等を含みます）を賠償するものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第15条（管理責任者）</h3>
            <p className="mt-2 text-sm text-gray-700">店舗オーナーは、本契約に基づく店舗ページの運営および販売を行うに際して、以下の義務を負います。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 管理責任者および店舗ページを利用した販売に関与する者（以下「管理責任者等」といいます）に対し、本サービスに関するシステムおよびその利用方法等を十分理解させること</li>
              <li>(2) 管理責任者等に対し、利用規約等を理解させた上、これを順守させること</li>
              <li>(3) 店舗オーナーは、管理責任者等が本規約の定めに違反し、当社に損害が生じた場合、管理責任者等と連帯して、当社に対し責任を負います。</li>
            </ul>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第16条（代理行為の禁止）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 本サービスは、あくまで、店舗オーナーが商品を販売する場を提供しているものであり、当社が自ら商品を販売し、または、店舗オーナーが当社を代理して販売を行うものではありません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、店舗オーナーに対し、本契約の締結により、いかなる代理権も付与しません。店舗オーナーは、当社を代理する旨の表示または当社もしくは当社の代理人であると誤認させるおそれがある表示をしてはなりません。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社は、本契約の締結により、当社のサービスマークを使用して営業または事業を行うことを店舗オーナーに許諾するものではありません。店舗オーナーは、当社に無断で、当社の社名、ロゴマーク、商標等を使用してはなりません。</p>
            <p className="mt-2 text-sm text-gray-700">4. 店舗オーナーは、顧客その他の第三者が、当社と店舗オーナーが第1項の関係を超えて、商品の販売に際して業務提携しているかのような、誤解が生じる一切の行為をしてはなりません。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第17条（法令等の遵守）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、法令等を順守し、また、商品を販売するための必要な許認可や承諾を、自らの責任と費用で取得し、これを維持しなければなりません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、商品の品質、機能等の記載に誤りや過不足がないよう万全の注意を払わなければならず、監督官庁または業界団体から商品のリコールや自主規制が要請された場合、速やかにこれに応じるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 店舗オーナーは、本規約および法令等が改定された場合、速やかにこれを確認しなければなりません。店舗オーナーは、当社から要求を受けた場合、店舗オーナーが本規約または法令等を順守しているかを当社が判断するために必要な情報を速やかに提出するものとします。</p>

            {/* 第４章　料金等 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第４章　料金等</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第18条（手数料）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、顧客のポイント購入金額に対して、手数料として次に掲げる金額を負担するものとします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 決済手数料：3.6%（クレジットカード決済代行費用）</li>
              <li>(2) システム利用料：3.0%（本サービスの利用料）</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 手数料は顧客による決済がなされた際に、当社の指定する決済代行業者において、購入金額から自動的に控除されます。</p>
            <p className="mt-2 text-sm text-gray-700">3. 手数料率は、当社の判断により変更することがあります。変更する場合は、事前に店舗オーナーに対し、通知を行います。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第19条（売上の入金）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 売上は、当社の指定する決済代行業者から、振込により店舗オーナーに支払われます。振込手数料は店舗オーナーの負担となります。</p>
            <p className="mt-2 text-sm text-gray-700">2. 入金先口座は、店舗オーナーが登録した銀行口座とします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 店舗オーナーに対する売上の入金は、当社の定める決済代行サービスのサイクルに従います。</p>
            <p className="mt-2 text-sm text-gray-700">4. 当社は、決済代行業者から手数料の支払いを受けますが、店舗オーナーと顧客との間の決済について、何ら関与するものではなく、顧客から資金を預かり、資金を移動し、又は為替取引を行うものではありません。</p>

            {/* 第５章　情報管理等 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第５章　情報管理等</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第20条（顧客情報）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、本サービスを利用するにあたり、個人情報の保護に関する法律上の義務を遵守しなければなりません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、顧客情報の漏洩が本サービスおよび当社、およびその関連会社、並びに、他の店舗オーナーの信用を毀損する行為であることを十分認識した上で、顧客情報の適切な保存および廃棄方法の策定、情報管理責任者の選任、従業員教育の実施等、顧客情報が外部に漏洩しないよう必要な措置をとらなければなりません。</p>
            <p className="mt-2 text-sm text-gray-700">3. 店舗オーナーまたは店舗オーナーが使用する者により顧客情報が他に漏洩した場合、店舗オーナーは、故意または過失の有無を問わず、これにより当社らにおいて生じた一切の損害（弁護士費用等を含む）を賠償する責を負います。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第21条（秘密保持義務）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、当社の書面による事前の承諾なくして、本契約の内容並びに本契約を通じて知り得た当社の営業上、技術上、その他一切の情報（以下「秘密情報」といいます）を、第三者に開示し、または本契約の目的以外に使用してはなりません。但し、以下の各号の一に該当する情報については、この限りではありません。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 知得した時点で、既に保有していた情報</li>
              <li>(2) 知得した時点で、既に公になっていた情報</li>
              <li>(3) 知得後に自己の責に拠らない事由により公になった情報</li>
              <li>(4) 第三者から秘密保持義務を負わずに適法に入手した情報</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 前項の規定にかかわらず、法令により、秘密情報の開示を義務付けられた場合、当社にその旨を事前に通知した上で、当該義務の範囲内で秘密情報を開示することができるものとします。但し、事前に通知することが困難な場合は、事後速やかに通知すれば足ります。</p>
            <p className="mt-2 text-sm text-gray-700">3. 本条の定めは、本契約終了後も有効に存続するものとします。</p>

            {/* 第６章　禁止事項・本サービスの運営等 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第６章　禁止事項・本サービスの運営等</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第22条（その他禁止事項）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、本サービスの利用において、以下の各号に定める行為をしてはならないものとします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 法令の定めに違反する行為またはそのおそれのある行為</li>
              <li>(2) 公の秩序または善良の良俗を害する行為</li>
              <li>(3) 消費者の判断に錯誤を与えるおそれのある行為</li>
              <li>(4) 当社、他の店舗オーナーその他の第三者に対し、財産権（知的財産権を含む）の侵害、名誉・プライバシーの侵害、誹謗中傷、その他の不利益を与える行為またはそのおそれのある行為</li>
              <li>(5) 本サービス外の店舗の宣伝、外部webサイトへのハイパーリンク、電話・FAX・電子メール等を利用した本サービス外取引についての優遇措置の表示、その他の方法により顧客を本サービス外の取引に誘引する行為</li>
              <li>(6) 商品の内容の不正操作</li>
              <li>(7) 顧客に対する不当な差別的取扱い</li>
              <li>(8) 顧客の個人情報の不正利用</li>
              <li>(9) 当社のサービス業務の運営・維持を妨げる行為</li>
              <li>(10) 本サービスに関し利用し得る情報を改ざんする行為</li>
              <li>(11) 有害なコンピュータプログラム、メール等を送信または書き込む行為</li>
              <li>(12) サーバその他当社のコンピュータに不正にアクセスする行為</li>
              <li>(13) 本サービスの信用を毀損する行為</li>
              <li>(14) 他の店舗オーナーの営業を不正に妨害する行為</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、店舗オーナーが以下のいずれかの事由に該当する場合には、店舗オーナーの出店の停止、店舗オーナーが表示した商品情報等の削除、出店停止理由の公表その他の必要な措置を取ることができます。この場合、店舗オーナーは速やかに当社の指示に従い、改善措置をとらなくてはなりません。なお、本条の定めは本規約上の他の規定に定める当社による本契約の解除、解約を妨げません。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 本規約に違反した場合</li>
              <li>(2) 店舗オーナーの店舗において商品を購入した顧客から商品等の不着、到着遅延または返金等に関する苦情が頻発したとき</li>
              <li>(3) その他本サービスの運営に支障をきたすと当社が判断した場合</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">3. 前項に基づき店舗オーナーが出店停止等の措置を受けている場合であっても、店舗オーナーは、本規約に基づく当社に対する債務の支払義務を負うものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第23条（サービスの一時停止）</h3>
            <p className="mt-2 text-sm text-gray-700">当社は次のいずれかの事由に該当する場合、当社の独自の判断により、店舗オーナーに事前に通知することなく本サービスの一部もしくは全部を一時中断、又は、停止することができます。店舗オーナーはサービス停止による手数料等の返還、損害の補償等を当社に請求しないこととします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 当社のサーバ、ソフトウェア等の点検、修理、補修、改良等のための停止</li>
              <li>(2) 火災、停電、天災などの不可抗力により、本サービスの提供が困難な場合</li>
              <li>(3) コンピュータ、通信回線等の事故、障害による停止</li>
              <li>(4) 当社、顧客、他の店舗オーナーその他の第三者の利益を保護するため、その他当社がやむを得ないと判断した場合における停止</li>
              <li>(5) その他サービスの継続が困難であると当社が判断した場合における停止</li>
            </ul>

            {/* 第７章　契約の終了等 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第７章　契約の終了等</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第24条（契約期間）</h3>
            <p className="mt-2 text-sm text-gray-700">本契約の有効期間は、アカウント発行日から1年間とします。ただし、期間満了の1ヶ月前までに当社または店舗オーナーの一方から解約の意思表示がない限り、1年間延長されるものとし、以後も同様とします。なお、店舗オーナーは、解約の意思表示を行う場合には、当社所定の手続きによるものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第25条（解除・解約）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 当社は、店舗オーナーが以下のいずれかの事由に該当した場合には、何らの催告なしに本契約を解除するとともに、直ちに店舗オーナーの店舗ページを本サイトおよびサーバから削除することができます。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 本規約に違反した場合</li>
              <li>(2) 顧客からの重大なクレームが継続した場合</li>
              <li>(3) ６ヶ月以上店舗ページの運営を行わなかった場合</li>
              <li>(4) 決済代行サービスの利用資格を消失した場合</li>
              <li>(5) 手形または小切手の不渡りが発生した場合</li>
              <li>(6) 差押え、仮差押え、仮処分その他の強制執行または滞納処分の申し立てを受けた場合</li>
              <li>(7) 破産手続開始、民事再生手続開始、会社更生手続開始または特別清算開始の申し立てを受け、または自ら申し立てた場合</li>
              <li>(8) 前三号の他、店舗オーナーの信用状態に重大な変化が生じた場合</li>
              <li>(9) 解散または営業停止状態となった場合</li>
              <li>(10) 当社による連絡が取れなくなった場合</li>
              <li>(11) 販売方法、取扱商品、その他業務運営について行政当局による注意または勧告を受けた場合</li>
              <li>(12) 販売方法、取扱商品、その他業務運営が公序良俗に反する場合</li>
              <li>(13) 前各号のいずれかに準ずる事由があると当社が判断した場合</li>
              <li>(14) その他当社が店舗オーナーとの本契約の継続が困難であると判断した場合</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 前項により本契約が終了した場合でも、当社は、店舗オーナーに対し、設備投資、費用負担、逸失利益その他店舗オーナーに生じた損害につき一切責任を負いません。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第26条（契約終了時）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 本契約が終了した場合、当社は、店舗オーナーの本サービスの利用を停止します。</p>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、本契約の終了時に、店舗オーナーおよび商品に関するすべての情報を、店舗オーナーに事前に通知することなく削除することができるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 本契約終了時に本契約に基づく未履行の債務がある場合には、当該債務についてはその履行が完了するまで本規約が適用されます。</p>
            <p className="mt-2 text-sm text-gray-700">4. 本契約終了時も、未配送の商品がある場合は配送義務が継続します。</p>

            {/* 第８章　雑則 */}
            <h2 className="mt-10 text-lg font-bold text-gray-900 border-b border-gray-300 pb-2">第８章　雑則</h2>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第27条（権利関係）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 本サービスに関する、イラスト、UI、デザイン、システム、その他一切のコンテンツに関する著作権、商標権、意匠権、特許権（特許を受ける権利を含む）、その他一切の権利は当社に帰属し、本契約の締結によって何らの権利も店舗オーナーに移転することはありません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、商品情報等を、本サービスの運営に必要な範囲で、自由に、改変、利用、頒布等をすることができ、店舗オーナーはこれに対し、権利行為をせず、また、著作者人格権を行使しないものとします。</p>
            <p className="mt-2 text-sm text-gray-700">3. 店舗オーナーは、店舗オーナー以外の第三者が著作権を有する著作物を出店ページに掲載する場合、事前に当該第三者から次に掲げる内容の許諾を受けるものとします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 当社および当社のグループ会社（以下「当社ら」と総称します）並びに店舗オーナーが利用・改変すること</li>
              <li>(2) 出店ページを閲覧した者その他当社が認める第三者が、当社が認める方法により、自己の管理するSNS等の媒体において、無償で利用・改変すること</li>
              <li>(3) 当社が認める第三者が、当社のサービスまたはインターネットサービスの向上に関わる研究・開発の目的により、無償で利用・改変すること</li>
            </ul>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第28条（権利の譲渡禁止）</h3>
            <p className="mt-2 text-sm text-gray-700">店舗オーナーは、本サイトに出店する権利その他本規約に基づく一切の権利を譲渡、転貸、担保差入その他形態を問わず、処分することはできません。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第29条（反社会的勢力との取引拒絶）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、店舗オーナーおよび店舗オーナーの親会社、子会社等の関連会社並びにそれらの役員、従業員等（以下あわせて「店舗オーナー等」といいます）が、現在、次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証します。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 暴力団（暴力団員による不当な行為の防止等に関する法律（平成3年法律第77号）（以下「暴対法」といいます）第2条第2号に規定する暴力団をいう。）</li>
              <li>(2) 暴力団員（暴対法第2条第6号に規定する暴力団員をいい、脱退後5年を経過しない者を含みます）</li>
              <li>(3) 暴力団準構成員</li>
              <li>(4) 暴力団関係企業</li>
              <li>(5) 総会屋等、社会運動標ぼうゴロ、政治活動標ぼうゴロ、または特殊知能暴力集団</li>
              <li>(6) 振り込め詐欺（成りすまし詐欺、架空請求詐欺、融資保証金詐欺、および還付金詐欺等を含みます）実行者または振り込め詐欺集団所属者</li>
              <li>(7) 前各号に定める者と密接な関わり（資金その他の便益提供行為を含みますが、これらに限りません）を有する者</li>
              <li>(8) その他前各号に準ずる者</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">2. 店舗オーナーは、店舗オーナー等が自らまたは第三者を利用して、当社または第三者に対し、次の各号事由に該当する行為を行わないことを確約するものとします。</p>
            <ul className="mt-2 text-sm text-gray-700 list-none pl-6 space-y-1">
              <li>(1) 暴力的な要求行為</li>
              <li>(2) 法的な責任を超えた不当な要求行為</li>
              <li>(3) 取引に関して脅迫的な言動をし、または暴力を用いる行為</li>
              <li>(4) 風説を流布し、偽計を用いもしくは威力を用いて第三者の信用を毀損し、またはその業務を妨害する行為</li>
              <li>(5) その他前各号に準ずる行為</li>
            </ul>
            <p className="mt-2 text-sm text-gray-700">3. 当社は、店舗オーナーが第１項または前項に違反している疑いがあると判断した場合、直ちに本契約および当社と店舗オーナー間に存在する他の契約の全部もしくは一部の履行を停止しまたは契約を解除できるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">4. 当社は、前項の規定により本契約を解除した場合、かかる解除によって店舗オーナーに生じた損害、損失および費用を補償する責任を負いません。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第30条（免責事項）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 店舗オーナーは、自己の責任と判断において本サービスを利用するものとします。当社は、本サービスの精度、完成度、正確性、妥当性、適用性、有用性および可用性について保証をしません。</p>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、店舗オーナーの使用する端末（スマートフォンおよびPCを含みます）で、本サービスが適切に起動することを保証しません。</p>
            <p className="mt-2 text-sm text-gray-700">3. 当社は、店舗オーナーと顧客間の取引について、仲介・あっせんを行うものではなく、取引に関する責任を負いません。</p>
            <p className="mt-2 text-sm text-gray-700">4. 当社は、店舗オーナーが出店に関して被った一切の損害（サーバまたはソフトウェアの障害・不具合・誤動作、本契約に基づく出店ページの全部または一部の滅失、サービスの全部または一部の停止、店舗オーナーの出店停止、顧客との取引等によるものを含みますが、それらに限られず、またその原因のいかんを問いません）について、当社の故意または重大な過失による場合を除き、賠償する責を負いません。</p>
            <p className="mt-2 text-sm text-gray-700">5. 当社の責任は、いかなる場合も店舗オーナーが過去12ヶ月間に当社に支払った手数料の総額を上限とします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第31条（規約の変更）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 当社は、当社の判断により、店舗オーナーに事前に通知することなく、本規約を変更することがあります。</p>
            <p className="mt-2 text-sm text-gray-700">2. 前項にかかわらず、手数料率の変更等、重要な変更を行う場合は、必要に応じて効力発生日前に告知します。</p>
            <p className="mt-2 text-sm text-gray-700">3. 本規約の変更は、当社のホームページ上に変更後の本規約を掲載した時点で効力を生ずるものとします。</p>
            <p className="mt-2 text-sm text-gray-700">4. 変更後に店舗オーナーが本サービスを利用した場合、変更後の規約に同意したものとみなします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第32条（本サービスの変更・停止・廃止）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 当社は、店舗オーナーに対する事前の承諾なく、本サービスの仕様等の変更もしくは追加またはサービスの停止もしくは廃止を行うことができます。</p>
            <p className="mt-2 text-sm text-gray-700">2. 当社は、サーバに障害が発生した等の理由により、本サイトにおける店舗オーナーの店舗運営に支障が生じると当社が判断した場合には、混乱防止のために必要となる措置を取ることができます。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第33条（会員規約の提供）</h3>
            <p className="mt-2 text-sm text-gray-700">当社は店舗オーナーに対し、会員規約のサンプルを提供するものとし、店舗オーナーはこれを自由に変更して使用することができます。但し、本規約に抵触する内容に変更することはできず、当社が提供した会員規約を使用したことにより、店舗オーナーが損害を負ったとしても、当社に責任は生じないものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第34条（分離可能性）</h3>
            <p className="mt-2 text-sm text-gray-700">本規約のいずれかの条項又はその一部が無効又は執行不能と判断された場合であっても、本規約の残りの規定は、継続して完全に効力を有します。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第35条（協議）</h3>
            <p className="mt-2 text-sm text-gray-700">本利用約款に定めのない事項または本利用約款の解釈に生じた疑義について、当社および店舗オーナーは、誠実に協議して解決を図るものとします。</p>

            <h3 className="mt-6 text-base font-semibold text-gray-900">第36条（準拠法および管轄裁判所）</h3>
            <p className="mt-2 text-sm text-gray-700">1. 本規約は日本法を準拠法とします。</p>
            <p className="mt-2 text-sm text-gray-700">2. 本規約に関する紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>

            <div className="mt-8 p-4 bg-gray-50 rounded-lg">
              <p className="text-sm text-gray-600">
                <strong>お問い合わせ先</strong><br />
                合同会社Codingholic<br />
                メール：support@joybase.jp
              </p>
            </div>

            <p className="text-sm text-gray-500 text-right mt-8">
              制定日：2025年10月20日<br />
              改定日：2026年2月12日
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
export default TermsPage;
